// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductShowcaseItem_wrapper__Z4oA0","image":"ProductShowcaseItem_image__p4wDh","description":"ProductShowcaseItem_description__sArH_"};